module.exports = __webpack_public_path__ + "static/media/light-theme-neutral-driving.9b872265.svg";